module.exports = __webpack_public_path__ + "media/img/Email-Intro-Banner-v2-283eaac1b0d0ebe77801cfba8e55e316.jpg";